
import React, { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
// import { loader } from './Images';
import useTailwindBrand from '../Theme/useTailwindBrand';
import { Backdrop, CircularProgress } from '@mui/material';
import { ENV_DECLARONS, ENV_VERIFIED_TRAINER, isBrandActive } from '../config/environment.config';
import { animationTeachr } from './Images';

const Loader = () => {
  const generalLoader = useSelector((state: any) => state.loader)
  const {classes, brandConfig} = useTailwindBrand()
  const [type, setType] = useState("")
  useEffect(() => {
    if (generalLoader.type) {
      setType(generalLoader.type)
    } else {
      setType("")
    }
  }, [generalLoader])
  const displayLoaderScreen = (type: string) => {
    if (type !== "") {
      switch (type) {
        case "dashboard-aici":
          return (
            // <div className='fixed z-50 flex items-center justify-center w-screen h-screen overflow-hidden bg-white'>
            //   <div className='w-1/3 lg:w-max'>
            //     <img src={loader} alt="chargement" />
            //     <p className='py-8 text-center text-first'>Chargement ...</p>
            //   </div>
            // </div>
            <div className={`h-screen w-full ${classes.bgRootLoader} `}>
              <div className="loader-container mx-auto h-full flex items-center lg:w-1/4 w-1/2">
                <Backdrop
                  sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: 'flex', flexDirection: 'column', gap: '20px' })}
                  open={true}
                >
                  <CircularProgress color="inherit" />
                  <img src={isBrandActive(ENV_VERIFIED_TRAINER) || isBrandActive(ENV_DECLARONS) ? brandConfig.assets.logoWhite : animationTeachr} alt="Chargement..." className={`loader mx-auto w-1/4`} />
                </Backdrop>
              </div>
            </div>
          )
        default:
          return
      }
    }
    return
  }
  return (
    <div>
      {displayLoaderScreen(type)}
    </div>
  );
};

export default Loader;